import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getUserInitials } from '@/presentation/pages/users/utils/get-user-initials.js';
import { BRAND_NAVY } from '@/shared/constants/brand.js';

interface Props {
    name: string;
    avatarUrl: string | null;
}

export function UserNameCell({ name, avatarUrl }: Props) {
    return (
        <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar data-testid="user-name-cell-avatar" src={avatarUrl ?? undefined} alt={name} sx={{ width: 32, height: 32, bgcolor: BRAND_NAVY, fontSize: 12 }}>
                {getUserInitials(name)}
            </Avatar>
            <Typography variant="body2" fontWeight={500}>
                {name}
            </Typography>
        </Stack>
    );
}
